/**
 * components/catalog/UnitOptions.js
 * <option>s for a unit <AppSelect>, grouped by family (Weight, Volume ...),
 * with plural duplicates left out unless the product already uses one. See
 * utilities/catalogTaxonomy.js for the rules.
 *
 *   <AppSelect value={unitId} onChange={...}>
 *     <option value="">No unit</option>
 *     <UnitOptions units={units} currentId={unitId} />
 *   </AppSelect>
 */
import React from "react";
import { groupUnits } from "../../utilities/catalogTaxonomy";

export default function UnitOptions({ units = [], currentId = null }) {
  const groups = groupUnits(units, { currentId });
  // One group (an older server with no families): no headings needed.
  if (groups.length === 1) {
    return groups[0].options.map((u) => (
      <option key={u._id} value={u._id}>
        {u.unit}
        {u.variantOf ? ` (use ${u.variantOf.unit})` : ""}
      </option>
    ));
  }
  return groups.map((g) => (
    <optgroup key={g.label} label={g.label}>
      {g.options.map((u) => (
        <option key={u._id} value={u._id}>
          {u.unit}
          {u.variantOf ? ` (use ${u.variantOf.unit})` : ""}
        </option>
      ))}
    </optgroup>
  ));
}
